import { DeploymentTypeEnum, InviteAction } from "@superblocksteam/shared";
import type {
  InviteOperation,
  PostInviteResponseDto,
} from "@superblocksteam/shared";

import { SUPERBLOCKS_UI_DEPLOYMENT_TYPE } from "env";
import { ADD_USERS_TO_ORG, INVITE_USERS_TO_ORG } from "pages/routes";
import { callServer, HttpMethod } from "store/utils/client";
import type { HttpError } from "store/utils/types";

export async function sendOrgInvitation({
  userEmails,
  organizationId,
  groupIds,
  onError,
  roleId,
}: {
  userEmails: string[];
  organizationId: string;
  groupIds?: string[];
  onError?: (e: HttpError) => void;
  roleId?: string;
}) {
  const url =
    SUPERBLOCKS_UI_DEPLOYMENT_TYPE === DeploymentTypeEnum.CLOUD_PREM
      ? ADD_USERS_TO_ORG()
      : INVITE_USERS_TO_ORG();

  if (SUPERBLOCKS_UI_DEPLOYMENT_TYPE === DeploymentTypeEnum.CLOUD_PREM) {
    const addUserResult = await callServer<PostInviteResponseDto>(
      {
        method: HttpMethod.Post,
        url,
        params: { orgId: organizationId },
        body: {
          emails: userEmails.map((email) => email.trim()),
          assignmentId: roleId,
        },
      },
      {
        notifyOnError: false,
        onError,
      },
    );
    return addUserResult;
  } else {
    // Use InviteRequest format for cloud
    const operations: InviteOperation[] = userEmails.map((email) => ({
      email: email.trim(),
      action: InviteAction.ADD_MEMBER,
    }));
    const invitationResult = await callServer<PostInviteResponseDto>(
      {
        method: HttpMethod.Post,
        url,
        params: { orgId: organizationId },
        body: {
          operations,
          groupIds,
          assignmentId: roleId,
        },
      },
      {
        notifyOnError: false,
        onError,
      },
    );
    return invitationResult;
  }
}
